import { render, staticRenderFns } from "./OGroupButton.vue?vue&type=template&id=1e81ae87&scoped=true"
import script from "./OGroupButton.vue?vue&type=script&lang=js"
export * from "./OGroupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e81ae87",
  null
  
)

export default component.exports